import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarLightReachCommand } from "./solar-lightreach-cache"
import type {
  SelectSolarLightReachOfferDto,
  SolarLightReachDto,
} from "../dto/solar-lightreach.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Choose a LightReach offer. The server voids the earlier quotes, creates the
 * offer's quote, back-solves Powur's margin to LightReach's system cost and
 * prices PowurOS once, so the price, payment, margin and savings all move.
 * A refusal writes nothing, but the offers may have gone stale meanwhile.
 */
export default function useSelectSolarLightReachOffer(): UseMutationResult<
  SolarLightReachDto,
  unknown,
  { proposalId: string; body: SelectSolarLightReachOfferDto }
> {
  return useSolarLightReachCommand(
    ({ proposalId, body }) =>
      solarProposalService.selectLightReachOffer(proposalId, body.offerId),
    `pricing`,
  )
}
